export default {
	data() {
		return {
			// 类型
			type: this.$route.query.type,
			// 文章列表
			articleList:[],
			// 正文
			html:'',
			// 正文标题
			title:'',
			// 标题索引
			currentIndex:0,
			// 侧边栏高度
			height:'220px',
			// 是否显示更多
			moreType:false
		}
	},
	watch: {
		$route() {
			this.getData()
			return this.type = this.$route.query.type
		}
	},
	methods: {
		//点击更多
		more(){
			if(this.moreType){
				this.moreType = false
				this.height = this.articleList.length * 34 + 120 +'px'
			}else{
				this.moreType = true
				this.height = '220px'
			}
		},
		// 获取数据
		getData() {
			this.$post('article/search', {
				offset: 0,
				length: 999,
                type: this.$route.query.type,
                shop_id: this.$store.state.store.id
			}).then(res => {
				console.log(res)
				this.articleList = res.data.result.data
				if(this.articleList.length != 0){
					this.html = this.articleList[0].data
					this.title = this.articleList[0].title
				}
				
				console.log(this.articleList)
			})
		},
		//换文本内容样式
		currentContent(item,index){
			this.html = item.data
			this.title = item.title
			this.currentIndex = index
		}
	},
	created() {

		this.getData()
	}
}
